import { useState } from "react";
import { useIntl } from "react-intl";
import { UserDetails } from "@/interfaces/userDetails";
import { Informations } from "./informations/Informations";
import { Payment } from "./payment/Payment";
import { Profile } from "./profile/Profile";
import styles from "./MyAccount.module.scss";
import { AccountTabs } from "../accountTabs/AccountTabs";

type MyAccountTabType = "profile" | "payment" | "informations";

type MyAccountProps = {
  userData: UserDetails;
  userToken?: string;
  email: string;
};

export const MyAccount = ({ userData, userToken, email }: MyAccountProps) => {
  const intl = useIntl();
  const tabs: MyAccountTabType[] = ["profile" /*, "payment", "informations"*/];
  const [selectedTab, setSelectedTab] = useState<MyAccountTabType>("profile");

  return (
    <div className={styles.myAccount}>
      <div className={styles.label}>
        {intl.formatMessage({ id: "myAccount" })}
      </div>
      <AccountTabs<MyAccountTabType>
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        tabs={tabs}
      />
      <div className={styles.currentTab}>
        {selectedTab === "profile" && (
          <Profile userData={userData} userToken={userToken} email={email} />
        )}
        {selectedTab === "payment" && <Payment />}
        {selectedTab === "informations" && <Informations />}
      </div>
    </div>
  );
};
